import { HeaderSteps } from '../service/header.service';

export const StepConfig = {
	NEW_PRODUCT_SURVEY: { name: 'client.calculation.new-product-survey', route: '/kalkulator/uj/termek-felmeres' },
	FAMILY_STATE: { name: 'client.family-state.title', route: '/kalkulator/:id/csaladi-allapot' },
	PROPERTY_QUESTIONS: { name: 'client.property.title', route: '/kalkulator/:id/ingatlan-kerdesek' },
	INCOME_AND_EDUCATION: {
		name: 'client.income-and-education.title',
		route: '/kalkulator/:id/jovedelem-es-vegzettseg',
	},
	AVAILABLE_AMOUNT: { name: 'client.available-amount.title', route: '/kalkulator/:id/elerheto-hitelosszeg' },
	CALCULATION_RESULT: { name: 'client.calculation-result.title', route: '/kalkulator/:id/kalkulacio-eredmenye' },
} as const;

export const calculatorSteps: Readonly<HeaderSteps[]> = [
	StepConfig.NEW_PRODUCT_SURVEY,
	StepConfig.FAMILY_STATE,
	StepConfig.PROPERTY_QUESTIONS,
	StepConfig.INCOME_AND_EDUCATION,
	StepConfig.AVAILABLE_AMOUNT,
	StepConfig.CALCULATION_RESULT,
];

export const stepInitializerWhiteList = [/kalkulator(?!valaszto)/];

export const hideHeaderRoutesList = [...Object.values(StepConfig).map((config) => config.route)];
